import { ContentAreaDemo } from "..\\..\\..\\..\\src\\demos\\content-area-demo";
import React from 'react';
export default {
  ContentAreaDemo,
  React
};